export const CHAT_TITLE_MAX_LENGTH = 120;
export function normalizeChatTitle(value) {
    return value.replace(/[\u0000-\u001f\u007f]/g, ' ').replace(/\s+/g, ' ').trim().slice(0, CHAT_TITLE_MAX_LENGTH);
}
/** Keep a chosen title stable across streaming callbacks, later turns, and history refreshes. */
export class ConversationTitles {
    titles = new Map();
    remember(session) {
        const existing = this.titles.get(session.id);
        if (!existing || (session.updatedAt ?? 0) > existing.updatedAt) {
            this.titles.set(session.id, { title: session.title, createdAt: session.createdAt, updatedAt: session.updatedAt ?? 0 });
        }
    }
    describe(id, fallback, createdAt) {
        const saved = this.titles.get(id);
        return saved ? { title: saved.title, createdAt: saved.createdAt } : { title: fallback, createdAt };
    }
    rename(id, value, createdAt, updatedAt = Date.now()) {
        const title = normalizeChatTitle(value);
        if (!title)
            throw new Error('Enter a chat name.');
        this.titles.set(id, { title, createdAt: this.titles.get(id)?.createdAt ?? createdAt, updatedAt });
        return title;
    }
    remove(id) { this.titles.delete(id); }
    clear() { this.titles.clear(); }
}
/** Order writes so an earlier auto-save cannot land after a rename and undo it. */
export class HistoryWriteQueue {
    tail = Promise.resolve();
    generation = 0;
    removed = new Map();
    /** Includes pending deletions so stale history refreshes cannot temporarily resurrect a chat. */
    isRemoved(id) { return this.removed.has(id); }
    run(write, conversationId) {
        // A save requested during deletion stays suppressed even when that deletion later fails.
        if (conversationId && this.removed.has(conversationId))
            return Promise.resolve(false);
        const generation = this.generation;
        const next = this.tail.then(async () => {
            if (generation !== this.generation || (conversationId && this.removed.has(conversationId)))
                return false;
            try {
                return await write();
            }
            catch {
                return false;
            }
        });
        this.tail = next;
        return next;
    }
    remove(id, erase) {
        const existing = this.removed.get(id);
        if (existing)
            return existing.pending ?? Promise.resolve(true);
        const generation = this.generation;
        const tombstone = {};
        this.removed.set(id, tombstone);
        const pending = this.run(erase).then(success => {
            // A late completion from a previous identity cannot clear this identity's deletion marker.
            if (generation === this.generation && this.removed.get(id) === tombstone) {
                if (success)
                    tombstone.pending = undefined;
                else
                    this.removed.delete(id);
            }
            return success;
        });
        tombstone.pending = pending;
        this.tail = pending;
        return pending;
    }
    reset() { this.generation++; this.tail = Promise.resolve(); this.removed.clear(); }
}
//# sourceMappingURL=conversationTitles.js.map